var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project-feature-item list-item",class:{
    selected: _vm.feature.enabled
  },attrs:{"data-testid":_vm.feature.id}},[_c('VueSwitch',{staticClass:"extend-left",attrs:{"value":_vm.feature.enabled}},[_c('ListItemInfo',{attrs:{"name":_vm.$t(_vm.feature.name),"description":_vm.$t(_vm.feature.description),"link":_vm.feature.link,"selected":_vm.feature.enabled}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }